import {Component, Input, OnChanges, inject, OnInit, OnDestroy} from '@angular/core';
import {MaterialModule} from '@app/material.module';
import {CommonModule} from '@angular/common';
import {NgScrollbarModule} from 'ngx-scrollbar';
import {TablerIconsModule} from 'angular-tabler-icons';
import {Room} from '@interfaces/room';
import {Technician} from '@interfaces/technician';
import {environment} from '@environment/environment';
import {ApiResponse} from '@interfaces/response';
import {RoomsService} from '@services/api/rooms/rooms.service';
import {Router} from '@angular/router';
import {UserStorageService} from '@services/local-storage/user-storage/user-storage.service';
import {Roles} from '@enums/Roles';

@Component({
  selector: 'app-support-sidebar-room',
  imports: [
    CommonModule,
    MaterialModule,
    NgScrollbarModule,
    TablerIconsModule
  ],
  standalone: true,
  templateUrl: './support-sidebar-room.component.html',
  styleUrl: './support-sidebar-room.component.scss'
})
export class SupportSidebarRoomComponent implements OnChanges, OnInit, OnDestroy {
  @Input({required: true}) uuid: string | null = null;
  @Input({required: true}) room: Room | null = null;

  private room_service: RoomsService = inject(RoomsService);
  private router: Router = inject(Router);
  private userStorageService = inject(UserStorageService);
  // As in the rooms page: a remote technician sees only the rooms where someone calls him, plus the one he is in
  private onlyCalls = false;
  public listRooms: Room[] = [];
  public connectlistRooms = [];

  private refreshIntervalId: any;

  avatar_url = environment.avatar_url;

  public technician!: Technician | undefined;

  ngOnInit(): void {
    this.userStorageService.getUserStorage().then(user => this.onlyCalls = user?.roles?.id === Roles.OPERATOR_BO);
    this.getRooms();
    this.refreshIntervalId = setInterval(() => this.getRooms(), 5000);
  }

  ngOnChanges(changes: any): void {
    if (changes['room']) {
      if (this.room) {
        this.technician = this.room?.technician;
        if (this.technician?.avatar) {
          this.avatar_url = this.technician.avatar;
        }
      }
    }
  }

  ngOnDestroy() {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
    }
  }

  private getRooms() {
    this.room_service.getRoomActivePromise().then((connect_list: any) => {
      this.connectlistRooms = connect_list;
      return this.room_service.getRoomsPromise();
    }).then((listRoom: ApiResponse<Room[]>) => {
      this.listRooms = listRoom.data;
      this.listRooms.forEach(itemRoom => {
        const connectedItem = this.connectlistRooms.find(item => item['connectionId'] === itemRoom.uuid);
        if (connectedItem) {
          itemRoom.connected = true;
          itemRoom.connectionNumber = connectedItem['connectionNumber'];
        } else {
          itemRoom.connected = false;
          itemRoom.connectionNumber = 0;
        }
      });
      if (this.onlyCalls) {
        this.listRooms = this.listRooms.filter(itemRoom => itemRoom.connected || itemRoom.uuid === this.uuid);
      }
    });
  }

  changeRoom(uuid: string) {
    this.router.navigate([`/support/room/${uuid}`]);
    return;
  }

}
